module.exports = __webpack_public_path__ + "static/img/10.b23b97b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/10.png
// module id = yDm2
// module chunks = 0